

export enum NabidkaType {INZERAT, PREPRAVA, VOZIDLO}